import { render } from "./face_3.svg?vue&type=template&id=226b3a58"
const script = {}
script.render = render

export default script